import { gql, useQuery } from "@apollo/client";
import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { BreadCrumb, BreadCrumbProp } from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { MenuComponent, MenuProps } from "../../../../components/MenuComponent";
import { Graph } from "../../../../generated/graph";
import { AdsCampaignAddMore } from "./AdsCampaignAddMore";
import moment from "moment";
import { ContextUser } from "../../../../context/ContextUser";

const QUERY = gql`
  query sellerAdsCampaigns {
    sellerAdsCampaigns {
      id
      name
      seller {
        id
        name
        contact
        origin
      }
      startDate
      endDate
      status
      items {
        status
        id
        product {
          code
          thumbnail
        }
        salesQty
        salesAmount
        clicks
        clicksByApp
        clicksByWebsite
        liveAt
        liveUrl
        type
      }
    }
  }
`;

const QUERY_BY_ID = gql`
  query sellerAdsCampaign($id: Int!) {
    sellerAdsCampaign(id: $id) {
      id
      name
      seller {
        id
        name
        contact
        origin
      }
      startDate
      endDate
      status
      items {
        settled
        biding
        budget
        status
        id
        product {
          code
          thumbnail
        }
        salesQty
        salesAmount
        clicks
        clicksByApp
        clicksByWebsite
        liveAt
        liveUrl
        type
        reach
      }
    }
  }
`;

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Applications",
    to: "#",
  },
  {
    text: "Products",
    to: "#",
  },
  {
    text: "Ads Campaigns",
    to: "/product/ads/list",
  },
];

function AdsCampaignField({
  data,
  actived,
  onDetail,
  onAddMore,
}: {
  data: Graph.SellerAdsCampaign;
  actived: boolean;
  onDetail: any;
  onAddMore: any;
}) {
  const { push } = useHistory();
  const menuItems: MenuProps[] = [
    {
      label: "Detail",
      onClick: onDetail,
      actived: true,
    },
    {
      label: "Add More Product",
      onClick: onAddMore,
      actived: true,
    },
    {
      label: "Duplicate Ads Campaign",
      onClick: () => {
        push("/product/ads/create/" + data.id);
      },
      actived: true,
    },
  ];

  return (
    <tr key={data.id!} style={actived ? { backgroundColor: "#65affd" } : {}}>
      <td>{data.name}</td>
      <td>{moment(data.startDate).format("YYYY-MM-DD")}</td>
      <td>{moment(data.endDate).format("YYYY-MM-DD")}</td>
      <td className="text-center">{data.items!.length}</td>
      <td className="text-center">
        <MenuComponent
          items={menuItems}
          menuButton={
            <Link to="#" style={{ textDecoration: "none", color: "#363636" }}>
              <i className="os-icon os-icon-more-vertical" style={{ fontSize: "15pt" }}></i>
            </Link>
          }
        />
      </td>
    </tr>
  );
}

export function AdsCampaignListScreen() {
  const [value, setValue] = useState(0);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const context = useContext(ContextUser);

  const { data, loading } = useQuery<Graph.Query>(QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: (res) => {
      if (res.sellerAdsCampaigns![0]) {
        setValue(res.sellerAdsCampaigns![0].id!);
      }
    },
  });
  const queryByID = useQuery<Graph.Query>(QUERY_BY_ID, {
    fetchPolicy: "no-cache",
    skip: value <= 0,
    variables: {
      id: Number(value),
    },
  });

  if (loading || data === undefined) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-12">
            Avaiable Balance:{" "}
            <b className={Number(context.merchant.balance) < 0 ? "text-danger mr-5" : "text-success mr-5"}>
              {context.merchant.balance} USD
            </b>
          </div>
        </div>
        <br />
        <br />
        <div className="row">
          <div className="col-md-6">
            <SectionBlock title="Ads Campaign List" transparent={false}>
              <Link to="/product/ads/create" className="btn btn-secondary btn-sm">
                Create new ads campaign
              </Link>
            </SectionBlock>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-12">
          Avaiable Balance:{" "}
          <b className={Number(context.merchant.balance) < 0 ? "text-danger mr-5" : "text-success mr-5"}>
            {context.merchant.balance} USD
          </b>
        </div>
      </div>
      <br />
      <br />
      <div className="row">
        <div className="col-md-5">
          <SectionBlock title="Ads Campaign List" transparent={false}>
            <Link to="/product/ads/create" className="btn btn-secondary btn-sm">
              Create new ads campaign
            </Link>
            <br />
            {error && <div className="alert alert-danger">{error}</div>}
            <br />
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th className="text-center">Total Product</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.sellerAdsCampaigns!.map((x: Graph.SellerAdsCampaign) => {
                  return (
                    <AdsCampaignField
                      key={x.id!}
                      data={x}
                      actived={x.id === value}
                      onDetail={() => setValue(x.id!)}
                      onAddMore={() => {
                        setValue(x.id!);
                        setShow(true);
                        console.log(x.id);
                      }}
                    />
                  );
                })}
              </tbody>
            </table>
            {!queryByID.loading && queryByID.data !== undefined && (
              <AdsCampaignAddMore
                show={show}
                onToggle={(e) => setShow(e)}
                data={queryByID.data.sellerAdsCampaign!}
                onComplete={(err) => {
                  setError(err);
                  setShow(false);
                }}
              />
            )}
          </SectionBlock>
        </div>
        <div className="col-md-7">
          {!queryByID.loading && queryByID.data !== undefined && (
            <SectionBlock title={queryByID.data.sellerAdsCampaign!.name!}>
              <div></div>
              <br />
              <br />
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th className="text-center">Biding</th>
                    <th className="text-center">Budget</th>
                    <th className="text-center">Reach</th>
                    <th className="text-center">Click</th>
                    <th className="text-center">Sale</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Spent</th>
                    <th className="text-center">Settled</th>
                  </tr>
                </thead>
                <tbody>
                  {queryByID.data.sellerAdsCampaign!.items &&
                    queryByID.data.sellerAdsCampaign!.items.map((x) => {
                      const spent = x.type === "CLICK" ? x.biding! * x.clicks! : x.biding! * x.salesQty!;
                      const settled =
                        x.settled === 0
                          ? x.settled
                          : x.type === "CLICK"
                          ? x.biding! * x.clicks!
                          : x.biding! * x.salesQty!;
                      return (
                        <tr key={x.id!}>
                          <td>
                            {x.product !== null && (
                              <div style={{ display: "flex" }}>
                                <img src={x.product!.thumbnail!} alt="" style={{ width: 50, height: 50 }} />
                                <span>
                                  {x.product!.code}
                                  <br />
                                  <span
                                    className={`badge rounded-pill bg-${
                                      x.type === "CLICK" ? "success" : "danger"
                                    } text-light`}
                                  >
                                    {x.type}
                                  </span>
                                </span>
                              </div>
                            )}
                          </td>
                          <td className="text-center">
                            <span className="text-success">{x.biding} USD</span>
                          </td>
                          <td className="text-center">
                            <span className="text-success">{x.budget} USD</span>
                          </td>
                          <td className="text-center">
                            <span>{x.reach}</span>
                          </td>
                          <td className="text-center">
                            <span>{x.clicks}</span>
                          </td>
                          <td className="text-center">
                            <span className="text-success">{x.salesAmount} USD</span>
                          </td>
                          <td className="text-center">
                            {x.status! === "PENDING" && (
                              <>
                                <span className="status-pill yellow"></span> <small>Pending</small>
                              </>
                            )}
                            {x.status! === "APPROVE" && (
                              <>
                                <span className="status-pill green"></span> <small>Delivering</small>
                              </>
                            )}
                            {x.status! === "REJECT" && (
                              <>
                                <span className="status-pill red"></span> <small>Reject</small>
                              </>
                            )}
                          </td>
                          <td className="text-center">
                            <span className="text-success">{spent.toFixed(2)} USD</span>
                          </td>
                          <td className="text-center">
                            <span className="text-success">{settled.toFixed(2) + " USD"}</span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </SectionBlock>
          )}
        </div>
      </div>
    </Content>
  );
}
